import { Icon } from '@fnacdarty/back-office-ui';
import styled, { css } from 'styled-components';

export const StyledCalendarContainer = styled.div`
	${(props) =>
		props.ismobile
			? css`
					width: 100%;
					height: calc(100vh - 140px);
					overflow-y: auto;
			  `
			: css`
					display: flex;
					justify-content: center;
					position: relative;
					margin-top: 20px;
					width: 100%;
			  `}
`;

export const StyledResourceSelection = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	height: auto;
`;

export const StyledResouceWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 700px;
	height: auto;
`;

export const StyledHeaderSelection = styled.div`
	margin-bottom: 20px;
`;

export const StyledInputContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
	position: relative;
	& > input {
		margin-bottom: 0px !important;
	}
	margin-bottom: 20px;
`;

export const StyledSearchIcon = styled(Icon)`
	position: absolute;
	right: 10px;
	top: 50%;
	transform: translateY(-50%);
	color: ${({ theme }) => theme.colors.text};
`;

export const StyledSelectionList = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	max-height: 350px;
	overflow-y: auto;
	&::-webkit-scrollbar {
		width: 10px;
	}
	&::-webkit-scrollbar-track {
		background: #f1f1f1;
	}
	&::-webkit-scrollbar-thumb {
		background-color: ${({ theme }) => theme.colors.primary};
		border-radius: 10px;
		border: 2px solid #f1f1f1;
	}
	&::-webkit-scrollbar-thumb:hover {
		background-color: ${({ theme }) => theme.colors.primaryLight};
	}
`;

export const StyledSelectionItem = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 50px;
	padding: 10px 20px;
	border-radius: 5px;
	cursor: pointer;
	&:hover {
		background-color: ${({ theme }) => theme.colors.primaryLight};
	}
	border: 1px solid ${({ theme }) => theme.colors.separator};
	& > span {
		font-size: 20px;
	}
	margin-bottom: 10px;
`;
export const StyledError = styled.p`
	width: 100%;
	color: ${({ theme }) => theme.colors.error};
`;

export const DivError = styled.div`
	background-color: #fce4e4;
	border: 1px solid #fcc2c3;
	float: left;
	padding: 20px 30px;
	width: 100%;
	height: 20%;
	text-align: center;
	margin: 5px;
`;

export const SpanError = styled.div`
	color: #cc0033;
	font-family: Helvetica, Arial, sans-serif;
	font-size: 13px;
	font-weight: bold;
	line-height: 20px;
	text-shadow: 1px 1px rgba(250, 250, 250, 0.3);
`;
